"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Icon_1 = require("../../atoms/Icon");

var IconLink_1 = require("../../molecules/IconLink");

var HeaderLegacy_1 = require("./HeaderLegacy");

var PkMetaBar =
/** @class */
function (_super) {
  __extends(PkMetaBar, _super);

  function PkMetaBar(props) {
    var _this = _super.call(this, props) || this;

    _this.updateValidityUser = function (e) {
      e.preventDefault();

      _this.setState(function (prevState) {
        return {
          // It seems that the validity is checked after re-render, prevent infinite loop here
          loginErrorOpenUser: prevState.loginErrorOpenUser || !_this.userInput.checkValidity()
        };
      });
    };

    _this.onChangeUser = function (e) {
      _this.setState({
        loginErrorOpenUser: _this.state.loginErrorOpenUser && !_this.userInput.checkValidity(),
        userValue: e.target.value
      });
    };

    _this.updateValidityPin = function (e) {
      e.preventDefault();

      if (!_this.state.pinValue && !_this.state.userValue) {
        window.location.replace(_this.props.applicationData.headerLoginURL);
      }

      _this.setState(function (prevState) {
        return {
          // It seems that the validity is checked after re-render, prevent infinite loop here
          loginErrorOpenPin: prevState.loginErrorOpenPin || !_this.pinInput.checkValidity()
        };
      });
    };

    _this.onChangePin = function (e) {
      _this.setState({
        loginErrorOpenPin: _this.state.loginErrorOpenPin && !_this.pinInput.checkValidity(),
        pinValue: e.target.value
      });
    };

    _this.requestPostboxCount = function () {
      fetch("/banking/rest/v1/postbox/retrievePostBoxCount", {
        method: "POST",
        body: JSON.stringify({}),
        headers: {
          "Content-type": "application/json; charset=UTF-8"
        }
      }).then(function (res) {
        return res.json();
      }).then(function (res) {
        var postBoxCount = res.result.items[0].postBoxCount;

        _this.setState({
          postBoxCount: postBoxCount
        });

        if (!postBoxCount) {
          setTimeout(_this.requestPostboxCount, PkMetaBar.postboxRefreshInterval);
        }
      })["catch"](function () {
        setTimeout(_this.requestPostboxCount, PkMetaBar.postboxRefreshInterval);
      });
    };

    _this.closeTooltip = function () {
      window.requestAnimationFrame(function () {
        return _this.setState({
          tooltipOpen: false
        });
      });
      utils_1.WidgetEvents.removeBodyClose(_this.closeTooltip);
    };

    _this.closeLoginInfo = function () {
      window.requestAnimationFrame(function () {
        return _this.setState({
          loginInfoOpen: false
        });
      });
      utils_1.WidgetEvents.removeBodyClose(_this.closeLoginInfo);
    };

    _this.state = {
      tooltipOpen: false,
      loginErrorOpenUser: false,
      loginErrorOpenPin: false,
      loginInfoOpen: false,
      userValue: "",
      pinValue: "",
      searchValue: "",
      postBoxCount: props.applicationData.postBoxCount
    };
    return _this;
  }

  PkMetaBar.prototype.componentDidMount = function () {
    if (this.props.applicationData.loginStatus === "FULL_LOGIN") {
      setTimeout(this.requestPostboxCount, PkMetaBar.postboxRefreshInterval);
    }
  };

  PkMetaBar.prototype.componentWillUnmount = function () {
    utils_1.WidgetEvents.removeBodyClose(this.closeTooltip);
    utils_1.WidgetEvents.removeBodyClose(this.closeLoginInfo);
  };

  PkMetaBar.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        applicationData = _a.applicationData,
        resourceBundleData = _a.resourceBundleData,
        frameworkData = _a.frameworkData,
        contentIncludesData = _a.contentIncludesData,
        metaTree = _a.metaTree;
    var _b = this.state,
        loginErrorOpenUser = _b.loginErrorOpenUser,
        loginErrorOpenPin = _b.loginErrorOpenPin,
        tooltipOpen = _b.tooltipOpen,
        loginInfoOpen = _b.loginInfoOpen,
        searchValue = _b.searchValue,
        postBoxCount = _b.postBoxCount;
    return React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "metabar " + CSSPrefix_1.lsgPre + "pkmetabar"
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "metabar-inner"
    }, React.createElement("div", {
      className: "mod mod-Suche"
    }, React.createElement("form", {
      method: "post",
      action: "",
      name: "searchform",
      onSubmit: function onSubmit(e) {
        e.preventDefault();
        HeaderLegacy_1.HeaderLegacy.openSearchPopup(contentIncludesData.searchDataUrl.url, contentIncludesData.searchDataUrl.popupHeight, contentIncludesData.searchDataUrl.popupWidth, searchValue);
      }
    }, React.createElement("input", {
      type: "search",
      className: "f-if-01",
      name: "SucheISDirekt",
      placeholder: contentIncludesData.searchDataUrl.placeholder,
      required: true,
      onInvalid: function onInvalid(e) {
        return e.preventDefault();
      },
      onChange: function onChange(e) {
        return _this.setState({
          searchValue: e.target.value
        });
      }
    }), React.createElement(IconLink_1.IconLink, {
      className: "f-sf-01",
      htmlAttrs: {
        type: "submit"
      },
      iconName: "i_211",
      look: IconLink_1.IconLink.Looks.NO_TEXT_NO_HOVER
    }, "Suche"))), applicationData.loginStatus && React.createElement(React.Fragment, null, React.createElement("ul", {
      className: "mod mod-NavUser"
    }, React.createElement("li", null, React.createElement("a", {
      href: "#loginStatus",
      className: "item item-loginStatus info-box-below",
      title: resourceBundleData.text_logindata,
      onClick: function onClick(e) {
        _this.setState(function (prevState) {
          return {
            loginInfoOpen: prevState.loginInfoOpen === false
          };
        });

        e.preventDefault();
      }
    }, React.createElement(Icon_1.Icon, {
      name: "i_695"
    }))), React.createElement("li", null, applicationData.loginStatus === "FULL_LOGIN" && !!postBoxCount && React.createElement("a", {
      id: "postBoxLink",
      href: resourceBundleData.link_postbox_url,
      className: "item item-messages u-color-primary",
      title: resourceBundleData.text_postbox_a_msg
    }, React.createElement(Icon_1.Icon, {
      name: "i_620"
    })), applicationData.loginStatus === "FULL_LOGIN" && !postBoxCount && React.createElement("a", {
      id: "postBoxLink",
      href: resourceBundleData.link_postbox_url,
      className: "item item-messages",
      title: resourceBundleData.link_postbox_tooltip
    }, React.createElement(Icon_1.Icon, {
      name: "i_620"
    })))), loginInfoOpen && React.createElement("div", {
      className: "info-box-msg posBelow",
      id: "loginStatus",
      ref: function ref(r) {
        utils_1.WidgetEvents.removeBodyClose(_this.closeLoginInfo);
        if (r) utils_1.WidgetEvents.addBodyClose(r, _this.closeLoginInfo);
      }
    }, React.createElement("table", null, React.createElement("tr", null, React.createElement("th", {
      colSpan: 2
    }, React.createElement("h1", {
      className: "h-03"
    }, resourceBundleData.text_logindata))), React.createElement("tr", null, React.createElement("td", null, resourceBundleData.settings_flyout_participant), React.createElement("td", null, applicationData.firstName, " ", applicationData.lastName)), React.createElement("tr", null, React.createElement("td", null, resourceBundleData.settings_flyout_userId), React.createElement("td", null, applicationData.userId)), React.createElement("tr", null, React.createElement("td", null, resourceBundleData.settings_flyout_lastLogin), React.createElement("td", null, applicationData.lastLogin))), React.createElement(IconLink_1.IconLink, {
      className: "close",
      iconName: Icon_1.Icon.Names.symbols___error,
      look: IconLink_1.IconLink.Looks.NO_TEXT_NO_HOVER,
      onClick: this.closeLoginInfo
    }, "x"))), React.createElement("div", {
      className: "mod mod-NavMeta",
      style: {
        marginRight: "48px",
        width: "auto"
      }
    }, metaTree.length > 0 && React.createElement("ul", null, metaTree.map(function (item) {
      return React.createElement("li", null, React.createElement("a", {
        className: "mn-01",
        href: item.href,
        target: item.target,
        onClick: item.onClick
      }, item.label));
    }))), frameworkData.headerLogin && !applicationData.loginStatus && !applicationData.loginPageShown && React.createElement("div", {
      className: "mod mod-HeaderLogin",
      style: {
        "float": "right",
        position: "relative",
        marginBottom: "0",
        top: "9px"
      }
    }, React.createElement("form", {
      id: "headerLoginForm",
      action: applicationData.headerLoginURL,
      method: "post",
      style: {
        textAlign: "right"
      }
    }, React.createElement("input", {
      type: "hidden",
      name: "headerLogin",
      value: "true"
    }), React.createElement("input", {
      type: "hidden",
      name: "sparte",
      value: applicationData.activeNavigationTreeIdentifier.shortName
    }), applicationData["com-coba-cif-campaignid-internal"] && React.createElement("input", {
      type: "hidden",
      name: "kid",
      value: applicationData["com-coba-cif-campaignid-internal"]
    }), applicationData["com-coba-cif-campaignid-external"] && React.createElement("input", {
      type: "hidden",
      name: "kid",
      value: applicationData["com-coba-cif-campaignid-external"]
    }), React.createElement("div", {
      className: "headerlogin-input-wrapper"
    }, React.createElement("div", null, React.createElement("input", {
      placeholder: resourceBundleData.user_id_label,
      className: "text-left required",
      type: "text",
      required: true,
      id: "teilnehmer",
      name: "teilnehmer",
      autoComplete: "off",
      pattern: "(?=(([0-9]+[^0-9]+)|([a-zA-Z]+[^a-zA-Z]+)|([@._\\-]+[^@._\\-]+)))[a-zA-Z0-9.@_\\-]{8,50}|[0-9]{8}|[0-9]{10}",
      maxLength: 50,
      tabIndex: 4,
      autoFocus: true,
      onInvalid: this.updateValidityUser,
      onChange: this.onChangeUser,
      ref: function ref(r) {
        return _this.userInput = r;
      }
    })), loginErrorOpenUser && React.createElement("div", {
      style: {
        position: "relative"
      }
    }, React.createElement("div", {
      className: "headerlogin-error-msg",
      id: "invalid-teilnehmer",
      style: {
        width: "200px"
      }
    }, React.createElement("div", {
      className: "inner"
    }, React.createElement("p", {
      dangerouslySetInnerHTML: {
        __html: resourceBundleData.loginForm_teilnemer_invalid
      }
    }))))), React.createElement("div", {
      className: "headerlogin-input-wrapper"
    }, React.createElement("div", null, React.createElement("input", {
      placeholder: resourceBundleData.pin_label,
      type: "password",
      className: "text-left ",
      required: true,
      id: "pin",
      name: "pin",
      autoComplete: "off",
      pattern: "^[A-Za-z0-9]{5,8}",
      maxLength: 8,
      tabIndex: 5,
      onInvalid: this.updateValidityPin,
      onChange: this.onChangePin,
      ref: function ref(r) {
        return _this.pinInput = r;
      }
    })), loginErrorOpenPin && React.createElement("div", {
      style: {
        position: "relative"
      }
    }, React.createElement("div", {
      className: "headerlogin-error-msg",
      id: "invalid-pin",
      style: {
        width: "200px"
      }
    }, React.createElement("div", {
      className: "inner"
    }, React.createElement("p", {
      dangerouslySetInnerHTML: {
        __html: resourceBundleData.loginForm_pin_invalid
      }
    }))))), React.createElement("div", {
      className: "headerlogin-input-wrapper"
    }, React.createElement("div", {
      style: {
        marginTop: "4px"
      }
    }, React.createElement("a", {
      className: "info-box-link",
      onClick: function onClick() {
        return _this.setState(function (prevState) {
          return {
            tooltipOpen: prevState.tooltipOpen === false
          };
        });
      }
    }, React.createElement(Icon_1.Icon, {
      name: "i_207"
    }))), tooltipOpen && React.createElement("div", {
      className: "info-box-msg",
      id: "headerLoginInfo",
      ref: function ref(r) {
        utils_1.WidgetEvents.removeBodyClose(_this.closeTooltip);
        if (r) utils_1.WidgetEvents.addBodyClose(r, _this.closeTooltip);
      }
    }, React.createElement("div", {
      className: "inner"
    }, React.createElement("p", {
      dangerouslySetInnerHTML: {
        __html: resourceBundleData.header_login_info
      }
    })), React.createElement("span", {
      className: "close",
      onClick: this.closeTooltip
    }, "x"))), React.createElement("div", {
      style: {
        "float": "left"
      }
    }, React.createElement("button", {
      id: "headerLoginSubmit",
      className: "b-01 b-a-04 b-g-01 login",
      type: "submit",
      title: resourceBundleData.link_login_tooltip
    }, resourceBundleData.link_login_label)), React.createElement("div", {
      style: {
        clear: "both"
      }
    }))), frameworkData.headerLogin && applicationData.loginStatus && React.createElement("a", {
      href: "/lp/logout",
      className: "btn b-01 b-a-05 b-g-01 iml-01 open",
      title: resourceBundleData.link_logout_tooltip
    }, resourceBundleData.link_logout_label)));
  };

  PkMetaBar.postboxRefreshInterval = 2000; // ms

  return PkMetaBar;
}(React.Component);

exports.PkMetaBar = PkMetaBar;